import { cx } from './internal/cx'
import './Stepper.css'

export type StepperProps = {
  label: string
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  /** Optional unit shown after the value, e.g. "glazen" or "uur". */
  unit?: string
}

function clamp(value: number, min: number, max: number | undefined): number {
  if (value < min) return min
  if (max !== undefined && value > max) return max
  return value
}

export function Stepper({ label, value, onChange, min = 0, max, step = 1, unit }: StepperProps) {
  const decreaseDisabled = value - step < min
  const increaseDisabled = max !== undefined && value + step > max

  return (
    <div className="ui-stepper">
      <span className="ui-stepper__label">{label}</span>
      <div className="ui-stepper__control" role="group" aria-label={label}>
        <button
          type="button"
          className={cx('ui-stepper__btn', decreaseDisabled && 'ui-stepper__btn--disabled')}
          aria-label={`Verlaag ${label}`}
          disabled={decreaseDisabled}
          onClick={() => onChange(clamp(value - step, min, max))}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" aria-hidden="true">
            <path d="M5 12h14" />
          </svg>
        </button>
        <span className="ui-stepper__value" aria-live="polite">
          {value}
          {unit && <span className="ui-stepper__unit"> {unit}</span>}
        </span>
        <button
          type="button"
          className={cx('ui-stepper__btn', increaseDisabled && 'ui-stepper__btn--disabled')}
          aria-label={`Verhoog ${label}`}
          disabled={increaseDisabled}
          onClick={() => onChange(clamp(value + step, min, max))}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" aria-hidden="true">
            <path d="M12 5v14" />
            <path d="M5 12h14" />
          </svg>
        </button>
      </div>
    </div>
  )
}
